<template>
	<div class="main-container">
		<div class="container">
			<section class="products-header">
				<span class="main-title">Lista de Productos</span>
				<button class="product-btn" @click="goToNewProduct">
					<span>Agregar Producto</span>
					<span class="product-add">+</span>
				</button>
			</section>
			<section class="table-overflow">
				<table class="table">
					<colgroup>
						<col class="name-col">
						<col class="name-col">
						<col class="image-previos-col">
						<col class="description-col">
						<col class="col-style">
						<col class="col-style">
					</colgroup>
					<thead>
						<tr>
							<th
								v-for="(col, indexCol) in columns"
								:key="indexCol"
							>{{col.title}}</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(row, indexRow) in products"
							:key="indexRow"
						>
							<td class="extreme-cell">{{getCategory(row)}}</td>
							<td>{{row.title}}</td>
							<td>
                <img
                  height="80"
                  :src="row.imagePrevious"
                  :alt="row.title" />
              </td>
							<td>
                <div v-html="row.description"></div></td>
							<td>{{getCarruselImages(row)}}</td>
							<td class="actions">
								<button
									class="edit-product"
									type="button"
									@click="editingProduct(row)"
								>Editar</button>
								<button
									class="remove-product"
									type="button"
									@click="deleteProduct(row)"
								>Eliminar</button>
							</td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<td></td>
						</tr>
					</tfoot>
				</table>
			</section>
			<section class="product-button">
				<button class="product-btn" @click="goToProducts">
					Ir a Productos
				</button>
			</section>
		</div>
	</div>
</template>
<script>
const computed = {
	products() {
		const { products } = this.$store.state;
		return products;
	},
};

function mounted() {
	// this.loadData();
	this.fetchProducts();
}

async function loadData() {
	const url = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/products`;
	const { data: response } = await this.$http.get(url);
	this.rows = response.data;
}

function getCategory(collection) {
	return collection.category && collection.category.data ?
		collection.category.data.title :
		'No tiene categoría enlazada';
	// return (collection.category.data || {}).title;
}

function goToNewProduct() {
	this.$router.push({ name: 'products-new' });
}

function goToProducts() {
	this.$router.push({ name: 'page-product' });
}

function editingProduct(product) {
	const params = {
		id: product.id,
		product,
	};
	this.$router.push({ name: 'products-edit', params });
}

async function deleteProduct({ id }) {
	const url = `${process.env.ARIS_URL}/edit/products/${id}`;
	await this.$http.delete(url);
	this.showNotification('Producto eliminado con éxito');
	this.loadData();
}

function getCarruselImages(row) {
	const result = row && row.dataImage ? row.dataImage.data
		.reduce((list, image) => list.concat(image.source[0]), [])
		.join(', ') : '';
	return result;
}

function data() {
	return {
		columns: [
			{ title: 'Categoría', value: 'category' },
			{ title: 'Nombre', value: 'title' },
			{ title: 'Vista Previa Producto', value: 'imagePreviews' },
			{ title: 'Descripción', value: 'details' },
			{ title: 'Carrusel de productos', value: 'dataImages' },
			{ title: '', value: 'actions' },
		],
		rows: [],
	};
}

export default {
	name: 'admin-products-list',
	computed,
	data,
	methods: {
		deleteProduct,
		editingProduct,
		getCategory,
		getCarruselImages,
		goToNewProduct,
		goToProducts,
		loadData,
	},
	mounted,
};
</script>

<style lang="scss" scoped>
.main-container {
	align-items: center;
	background-color: map-get($colors, background-products);
	display: flex;
	font-family: map-get($fonts, open-regular);
	justify-content: center;
	padding: 25px;
}

.container {
	width: 100%;
}

.products-header {
	align-items: center;
	border-bottom: 3px solid map-get($colors, black-dark);
	display: flex;
	justify-content: space-between;
	margin-bottom: 41px;
	padding-bottom: 12px;
}

.product-btn {
	align-items: center;
	background-color: map-get($colors, black-dark);
	color: white;
	display: flex;
	font-size: map-get($sizes, medium);
	height: 45px;
	justify-content: space-evenly;
	width: 192px;
}

.product-add {
	font-size: 28px;
}

.table {
	background-color: white;
	font-size: map-get($sizes, small);
	table-layout: fixed;
	width: 100%;

	.col-style {
		width: auto;
	}

	thead {
		border-bottom: 1px solid map-get($colors, line-grey);
		color: map-get($colors, grey-input);

		tr {

			th {
				height: 56px;
				vertical-align: middle;
			}
		}
	}

	tbody {

		tr {
			border-bottom: 1px solid black;

			td {
				height: 78px;
				overflow: scroll;
				padding: 0 5px;
				text-align: center;
				vertical-align: middle;
				white-space: nowrap;
			}
		}
	}

	tfoot {

		tr {

			td {
				height: 40px;
			}
		}
	}
}

.product-button {
	align-items: center;
	display: flex;
	justify-content: center;
	margin-top: 40px;
}

.edit-product {
	border: 1px solid map-get($colors, black-dark);
		border-radius: 3px;
		color: map-get($colors, black-dark);
}

.remove-product {
	border: 1px solid map-get($colors, red-icon);
		border-radius: 3px;
		color: map-get($colors, red-icon);
}

.actions {
	white-space: nowrap;
}

.name-col {
	width: 100px;
}

.image-previos-col {
	max-width: 120px;
}

.description-col {
	width: 250px;
}

.table-overflow {
	overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/page-products-list.vue